import { defineStore } from "pinia";
// import userData from '../views/GoogleLogin.vue'

export const useCartStore = defineStore("cart", {
    state: () => ({
        cartItems: new Array,
    }),
    getters: {
        getState(state) {
            return state
        }
    },

    actions: {
        addItem(item) {
            // console.log(this.cartItems.find(cartItem => cartItem.partNumber == item.partNumber));
            if (this.cartItems.find(cartItem => cartItem.partNumber == item.partNumber)) {
                const index = this.cartItems.findIndex(x => x.partNumber == item.partNumber);
                this.cartItems[index].qty++
            } else {
                this.cartItems.push(item)
            }
            return this.cartItems
        },
        getItems() {
            return this.cartItems
        },
        removeItem(item) {
            const index = this.cartItems.findIndex(x => x.partNumber == item.partNumber);
            if (this.cartItems[index].qty > 0) {
                this.cartItems[index].qty--
            } else {
                this.clearItem(item)
            }
            return this.cartItems
        },
        clearItem(item) {
            const index = this.cartItems.findIndex(x => x.partNumber == item.partNumber);
            this.cartItems[index].qty = 1
            this.cartItems.splice(index, 1)

            return this.cartItems
        }
        ,
        clearAll() {
            this.cartItems.map(item => item.qty = 1)
            return this.cartItems = new Array
        }
    }
})